// F30: readable lines from the backend's assumed_defaults report
// ({property: {field: value}}), for the "defaults were used" banner.

export type AssumedDefaults = Record<string, Record<string, number | string>>;

const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export function summariseAssumed(report: AssumedDefaults | undefined | null): { property: string; items: string[] }[] {
  if (!report) return [];
  return Object.entries(report)
    .filter(([, fields]) => Object.keys(fields).length > 0)
    .map(([property, fields]) => {
      const remaining: Record<string, number | string> = { ...fields };
      const items: string[] = [];
      for (const prefix of ['adr', 'occupancy']) {
        const keys = MONTHS.map((m) => `${prefix}_${m}`);
        const values = keys.map((k) => remaining[k]);
        if (values.every((v) => v !== undefined) && new Set(values).size === 1) {
          items.push(`${prefix} (all months) = ${values[0]}`);
          keys.forEach((k) => delete remaining[k]);
        }
      }
      Object.keys(remaining).sort().forEach((k) => items.push(`${k} = ${remaining[k]}`));
      return { property, items: items.sort() };
    });
}
